import {Separator} from 'platform/components';
import {Box, HStack, Icon, Text, VStack} from 'platform/foundation';

import {Link} from 'react-router-dom';

import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate, useCodeLists} from '@dms/settings/shared';

import {composePath} from 'shared/web';

export function Codelists() {
  const {data: codelist} = useCodeLists();

  return (
    <SettingsTemplate
      header={{title: i18n.t('page.codelists.pageTitle')}}
      data-testid={testIds.settings.codelists('layout')}
    >
      <Box
        borderRadius="small"
        boxShadow="elevation_1"
        border="1px"
        borderColor="palettes.neutral.60.100"
        backgroundColor="general.white"
      >
        {codelist?.sales?.map((codelist) => (
          <Link
            to={composePath(settingsRoutes.codelistDetail, {
              params: {id: codelist.codelistId},
            })}
            key={codelist.codelistId}
          >
            <VStack height={12}>
              <Box paddingHorizontal={4} paddingVertical={3}>
                <HStack justify="space-between">
                  <Text>{codelist.name}</Text>
                  <Icon value="navigation/chevron_right" />
                </HStack>
              </Box>
              <Separator spacing={0} />
            </VStack>
          </Link>
        ))}
      </Box>
    </SettingsTemplate>
  );
}
